import { render, staticRenderFns } from "./DashboardClienteMaps.vue?vue&type=template&id=8e27f4ce&scoped=true&"
import script from "./DashboardClienteMaps.vue?vue&type=script&lang=js&"
export * from "./DashboardClienteMaps.vue?vue&type=script&lang=js&"
import style0 from "./DashboardClienteMaps.vue?vue&type=style&index=0&id=8e27f4ce&scoped=true&lang=css&"
import style1 from "./DashboardClienteMaps.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e27f4ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
